import { h, Component, forceUpdate, Prop } from '@stencil/core';
import state, { store } from '../../state';
import { SubmitEventArg } from '../../types';

@Component({
  tag: 'om-screen-switcher',
})
export class ScreenSwitcher {
  @Prop() handleSubmit: (d: SubmitEventArg) => void;
  @Prop() unmount?: () => void;

  render() {
    switch (state.currentScreen) {
      case 'email':
        return <om-email-screen handleSubmit={this.handleSubmit} screenValues={state.content.email} />;
      case 'sms':
        return <om-sms-screen handleSubmit={this.handleSubmit} screenValues={state.content.sms} />;
      case 'success':
        return <om-success-screen screenValues={state.content.success} unmount={this.unmount} />;
      default:
        // Fallback for 'miniOverlay' or unexpected values
        return <om-email-screen handleSubmit={this.handleSubmit} screenValues={state.content.email} />;
    }
  }
  componentDidRender() {
    if (state.mode !== 'preview') return;
    store.onChange('content', () => forceUpdate(this));
    store.onChange('currentScreen', () => forceUpdate(this));
  }
}
